document.addEventListener('DOMContentLoaded', () => {
  lazyLoadResources({
    selector: '.js-slider-card-lazy',
    styles: [
      '/local/templates/template1/public/css/vendor/swiper-bundle.min.css',
      '/local/templates/template1/public/css/common/blocks/card/card.css'
    ],
    scripts: [
      '/local/templates/template1/public/js/vendor/swiper-bundle.min.js',
      '/local/templates/template1/public/js/common/card-slider.js'
    ]
  })
})
